export const COLORS = {
  RED: '#EB5769',
  RED10: '#f43',
  RED20: '#eb57691a',
  GREEN: '#5DC983',
  GREEN10: 'linear-gradient(0deg, #5DC983, #5DC983),linear-gradient(0deg, #FFFFFF, #FFFFFF)',
  GREEN20: '#5dc9831a',
  GREEN30: '#5dc98333',
  GREEN40: '#5dc98326',
  GREEN50: '#1EB06E',
  GREEN60: '#f4fbf6',
  GREEN70: '#0c3035',
  GREEN80: '#b3f10d',
  GREEN90: '#F8FBFB',
  GREEN100: '#00524F0D',
  WHITE: '#FFFFFF',
  WHITE10: '#ffffff0d',
  WHITE20: '#F7F8FB',
  WHITE30: '#ffffffb3',
  WHITE40: '#ffffff14',
  WHITE50: '#f7f8fbbf',
  WHITE60: '#ffffff1a',
  BLACK: '#000211',
  BLACK10: '#101221',
  BLACK20: '#262736',
  BLACK30: '#1B2149',
  BLACK40: '#171215',
  BLACK50: '#1b2149e6',
  BLACK60: '#2F3342',
  BLACK70:
    'linear-gradient(179deg, rgba(125, 121, 255, 0.10) -7.44%, rgba(93, 89, 240, 0.10) 115.82%), #1D2132',
  BLACK80: '#141736',
  BLACK90: '#1b2149d9',
  BLACK100: '#1b2149bf',
  BLACK110: 'linear-gradient(0deg, rgba(0, 0, 0, 0.35) 0%, rgba(0, 0, 0, 0.35) 100%)',
  BLACK120: '#0000008c',
  BLACK130: '#1b2149cc',
  BLACK140: '#0E0D2B',
  BLACK150: '#0e0d2b80',
  BLACK160: '#111632d9',
  BLACK170: '#1c2349',
  BLACK180: '#0000000A',
  BLACK190: '#011B3B',
  BLACK200: '#161617',
  BLACK210: '#00000091',
  GRAY: '#F9F9FC',
  GRAY10: '#E3E4E7',
  GRAY20: '#787C8F',
  GRAY30: '#8393A6',
  GRAY40: '#1D2132',
  GRAY50: '#00000008',
  GRAY60: '#8393a633',
  GRAY70: '#8393a640',
  GRAY80: '#0000001a',
  GRAY90: '#78788029',
  GRAY100: '#1b21498c',
  GRAY110: '#1b214980',
  GRAY120: '#00000012',
  GRAY130: '#E1E5EB',
  GRAY140: '#f7f7f7',
  GRAY150: '#1f2130',
  GRAY160: '#707991',
  GRAY170: '#E6E9ED',
  GRAY180: '#282C3C',
  GRAY190: '#787c8f1a',
  GRAY200: '#1b2149a6',
  GRAY210: '#F0F0F0',
  GRAY220: '#F3F5F7',
  GRAY230: '#82859B',
  GRAY240: '#1b21491a',
  GRAY250: '#E3E3EA',
  GRAY260: '#8393a6bf',
  GRAY270: '#E9EDF0',
  GRAY280: '#787c8f26',
  GRAY290: '#0000001f',
  GRAY300: '#1b214926',
  GRAY310: '#D9D9D9',
  GRAY320: '#0000000f',
  GRAY330: '#F5F5F5',
  GRAY340: '#e3eaf4cc',
  GRAY350: '#A5B4CB',
  GRAY360: '#F6F6F6',
  GRAY370: '#00000029',
  GRAY380: '#0c1a4b3d',
  GRAY390: '#3232470d',
  GRAY400: '#E0E4E9',
  GRAY410: '#484C59',
  GRAY420: '#f1f1f1',
  GRAY430: '#F5F6F7',
  GRAY440: '#f9f9f9',
  GRAY450: '#00000026',
  GRAY460: '#8393a626',
  GRAY470: '#0000000d',
  GRAY480: '#eaeaea',
  GRAY490: '#8393a680',
  GRAY500: '#ffffff91',
  GRAY510: '#E6E6E6',
  GRAY520: '#8393a61a',
  GRAY530: '#e8e8e8',
  GRAY540: '#00000014',
  GRAY550: '#e0e0de',
  GRAY560: '#0e0d2b80',
  GRAY570: '#e0e0deb3',
  GRAY580: '#00000017',
  GRAY590: '#f4f4f4',
  GRAY600: '#f3f5f7',
  GRAY700: '#e0e4e9',
  GRAY710: '#f8f8fb',
  GRAY720: '#DDDDDD',
  GRAY730: '#F3F3F3',
  GRAY740: '#8F8F8F',
  GRAY750: '#EFEFEF',
  GRAY760: '#A8A8A8',
  GRAY770: '#F6F7FA',
  GRAY780: '#DADFE6',
  GRAY790: '#6D7588',
  GRAY800: '#747474',
  GRAY810: '#F8F8F8',
  GRAY820: '#F4F5F7',
  GRAY830: '#E7EEEC',
  GRAY840: '#989898',
  GRAY850: '#ECECEC',
  GRAY860: '#646667',
  TRANSPARENT: 'transparent',
  PURPLE: '#00524F',
  PURPLE10: '#003F3C',
  PURPLE20: 'linear-gradient(0deg, rgba(0, 82, 79, 0.15) 0%, rgba(0, 82, 79, 0.15) 100%), #0A1D1C',
  PURPLE30:
    'linear-gradient(179deg, rgba(0, 82, 79, 0.10) -7.44%, rgba(0, 63, 60, 0.10) 115.82%), #FFF',
  PURPLE40: '#D0E4E3',
  PURPLE50:
    'linear-gradient(0deg, #FFFFFF, #FFFFFF),linear-gradient(178.89deg, #00524F -7.44%, #003F3C 115.82%)',
  PURPLE60: '#004845',
  PURPLE70: 'linear-gradient(0deg, rgba(0, 82, 79, 0.10) 0%, rgba(0, 82, 79, 0.10) 100%), #FFF',
  PURPLE80: 'linear-gradient(179deg, #00524F -7.44%, #003F3C 115.82%), #FFFFFF',
  PURPLE90: 'linear-gradient(179deg, #00524F -7.44%, #003F3C 115.82%)',
  PURPLE100: 'linear-gradient(179deg, rgba(0, 82, 79, 0.05) -7.44%, rgba(0, 63, 60, 0.05) 115.82%)',
  PURPLE110: 'linear-gradient(0deg, rgba(0, 82, 79, 0.15) 0%, rgba(0, 82, 79, 0.15) 100%), #FFFFFF',
  PURPLE120: '#F4FBFA',
  PURPLE130: 'linear-gradient(0deg, #003F3C 0%, #003F3C 100%), #FFF',
  PURPLE140: '#00524F1A',
  PURPLE150: '#E6F3F2',
  PURPLE160: '#003F3C59',
  PURPLE170: '#E2ECEB',
  PURPLE180:
    'linear-gradient(179deg, rgba(0, 82, 79, 0.05) -7.44%, rgba(0, 63, 60, 0.05) 115.82%), #FFF',
  PURPLE190:
    'linear-gradient(179deg, rgba(0, 82, 79, 0.20) -7.44%, rgba(0, 63, 60, 0.20) 115.82%), #FFF',
  PURPLE200:
    'linear-gradient(179deg, rgba(0, 82, 79, 0.07) -7.44%, rgba(0, 63, 60, 0.07) 115.82%), #FFF',
  PURPLE210: '#00524F61',
  PURPLE220: '#00524F00',
  PURPLE230:
    'linear-gradient(179deg, rgba(0, 82, 79, 0.07) -7.44%, rgba(0, 63, 60, 0.07) 115.82%), #0B1414',
  PURPLE240: 'linear-gradient(0deg, rgba(0, 82, 79, 0.10) 0%, rgba(0, 82, 79, 0.10) 100%), #192524',
  PURPLE250:
    'linear-gradient(179deg, rgba(0, 82, 79, 0.10) -7.44%, rgba(0, 63, 60, 0.10) 115.82%), #FFF',
  PURPLE260: '#00524F1A',
  PURPLE270: '#CFE7E6',
  BLUE: 'linear-gradient(0deg, #101221, #101221),linear-gradient(0deg, #262736, #262736)',
  BLUE10: '#3440C3',
  BLUE20: '#199BDF',
  BLUE30: '#1d2132d9',
  BLUE40: '#1754ca1a',
  BLUE50: '#1754CA',
  BLUE60: '#0177fb33',
  BLUE70: '#0177FB',
  BLUE80: 'linear-gradient(360deg, #0073FF -1.25%, #00C2FF 100%)',
  BLUE90: '#0094ff1a',
  BLUE100: '#3730a3',
  BLUE110: '#e0e7ff',
  YELLOW: '#F2AF4C',
  YELLOW10: '#f2af4c1a',
  YELLOW20: '#f2af4c33',
  YELLOW30: '#FBCF00',
  YELLOW40: '#FFA800',
  YELLOW50: '#FEF3C7',
  BROWN: '#92400E',
}

export const LIGHT_COLORS = {
  'L-WHITE-D-BLACK10': COLORS.WHITE,
  'L-BLACK30-D-WHITE': COLORS.BLACK30,
  'L-BLACK30-D-GRAY20': COLORS.BLACK30,
  'L-GRAY-D-GRAY40': COLORS.GRAY,
  'L-GRAY10-D-BLACK20': COLORS.GRAY10,
  'L-GRAY30-D-GRAY20': COLORS.GRAY30,
  'L-WHITE-D-BLUE': COLORS.WHITE,
  'L-PURPLE110-D-PURPLE20': COLORS.PURPLE110,
  'L-TRANSPARENT-D-BLACK20': COLORS.TRANSPARENT,
  'L-PURPLE30-D-WHITE10': COLORS.PURPLE30,
  'L-WHITE-D-WHITE10': COLORS.WHITE,
  'L-BLACK30-D-WHITE20': COLORS.BLACK30,
  'L-BLUE10-D-WHITE': COLORS.BLUE10,
  'L-GRAY50-D-GRAY40': COLORS.GRAY50,
  'L-GRAY10-D-WHITE40': COLORS.GRAY10,
  'L-GRAY140-D-GRAY150': COLORS.GRAY140,
  'L-GRAY160-D-GRAY20': COLORS.GRAY160,
  'L-GRAY170-D-GRAY180': COLORS.GRAY170,
  'L-GRAY100-D-GRAY20': COLORS.GRAY100,
  'L-GRAY110-D-BLUE30': COLORS.GRAY110,
  'L-GRAY10-D-GRAY190': COLORS.GRAY10,
  'L-GRAY120-D-GRAY190': COLORS.GRAY120,
  'L-GRAY30-D-WHITE20': COLORS.GRAY30,
  'L-WHITE-D-GRAY40': COLORS.WHITE,
  'L-GRAY200-D-GRAY20': COLORS.GRAY200,
  'L-GRAY230-D-GRAY20': COLORS.GRAY230,
  'L-BLACK50-D-WHITE20': COLORS.BLACK50,
  'L-GRAY220-D-GRAY40': COLORS.GRAY220,
  'L-GRAY240-D-WHITE40': COLORS.GRAY240,
  'L-GRAY250-D-BLACK60': COLORS.GRAY250,
  'L-PURPLE30-D-BLACK70': COLORS.PURPLE30,
  'L-GRAY260-D-GRAY20': COLORS.GRAY260,
  'L-BLUE10-D-PURPLE10': COLORS.BLUE10,
  'L-TRANSPARENT-D-WHITE40': COLORS.TRANSPARENT,
  'L-GRAY270-D-WHITE40': COLORS.GRAY270,
  'L-BLACK80-D-WHITE50': COLORS.BLACK80,
  'L-GRAY10-D-GRAY280': COLORS.GRAY10,
  'L-GRAY300-D-WHITE60': COLORS.GRAY300,
  'L-GRAY360-D-GRAY180': COLORS.GRAY360,
  'L-PURPLE200-D-PURPLE230': COLORS.PURPLE200,
  'L-GRAY330-D-GRAY180': COLORS.GRAY330,
  'L-GRAY100-D-GRAY30': COLORS.GRAY100,
  'L-PURPLE30-D-PURPLE240': COLORS.PURPLE30,
  'L-PURPLE40-D-WHITE40': COLORS.PURPLE40,
  'L-GRAY60-D-WHITE40': COLORS.GRAY60,
  'L-GRAY130-D-BLACK60': COLORS.GRAY130,
  'L-WHITE-D-GRAY180': COLORS.WHITE,
  'L-GRAY400-D-GRAY410': COLORS.GRAY400,
}

export const DARK_COLORS: typeof LIGHT_COLORS = {
  'L-WHITE-D-BLACK10': COLORS.BLACK10,
  'L-BLACK30-D-WHITE': COLORS.WHITE,
  'L-BLACK30-D-GRAY20': COLORS.GRAY20,
  'L-GRAY-D-GRAY40': COLORS.GRAY40,
  'L-GRAY10-D-BLACK20': COLORS.BLACK20,
  'L-GRAY30-D-GRAY20': COLORS.GRAY20,
  'L-WHITE-D-BLUE': COLORS.BLUE,
  'L-PURPLE110-D-PURPLE20': COLORS.PURPLE20,
  'L-TRANSPARENT-D-BLACK20': COLORS.BLACK20,
  'L-PURPLE30-D-WHITE10': COLORS.WHITE10,
  'L-WHITE-D-WHITE10': COLORS.WHITE10,
  'L-BLACK30-D-WHITE20': COLORS.WHITE20,
  'L-BLUE10-D-WHITE': COLORS.WHITE,
  'L-GRAY50-D-GRAY40': COLORS.GRAY40,
  'L-GRAY10-D-WHITE40': COLORS.WHITE40,
  'L-GRAY140-D-GRAY150': COLORS.GRAY150,
  'L-GRAY160-D-GRAY20': COLORS.GRAY20,
  'L-GRAY170-D-GRAY180': COLORS.GRAY180,
  'L-GRAY100-D-GRAY20': COLORS.GRAY20,
  'L-GRAY110-D-BLUE30': COLORS.BLUE30,
  'L-GRAY10-D-GRAY190': COLORS.GRAY190,
  'L-GRAY120-D-GRAY190': COLORS.GRAY190,
  'L-GRAY30-D-WHITE20': COLORS.WHITE20,
  'L-WHITE-D-GRAY40': COLORS.GRAY40,
  'L-GRAY200-D-GRAY20': COLORS.GRAY20,
  'L-GRAY230-D-GRAY20': COLORS.GRAY20,
  'L-BLACK50-D-WHITE20': COLORS.WHITE20,
  'L-GRAY220-D-GRAY40': COLORS.GRAY40,
  'L-GRAY240-D-WHITE40': COLORS.WHITE40,
  'L-GRAY250-D-BLACK60': COLORS.BLACK60,
  'L-PURPLE30-D-BLACK70': COLORS.BLACK70,
  'L-GRAY260-D-GRAY20': COLORS.GRAY20,
  'L-BLUE10-D-PURPLE10': COLORS.PURPLE10,
  'L-TRANSPARENT-D-WHITE40': COLORS.WHITE40,
  'L-GRAY270-D-WHITE40': COLORS.WHITE40,
  'L-BLACK80-D-WHITE50': COLORS.WHITE50,
  'L-GRAY10-D-GRAY280': COLORS.GRAY280,
  'L-GRAY300-D-WHITE60': COLORS.WHITE60,
  'L-GRAY360-D-GRAY180': COLORS.GRAY180,
  'L-PURPLE200-D-PURPLE230': COLORS.PURPLE230,
  'L-GRAY330-D-GRAY180': COLORS.GRAY180,
  'L-GRAY100-D-GRAY30': COLORS.GRAY30,
  'L-PURPLE30-D-PURPLE240': COLORS.PURPLE240,
  'L-PURPLE40-D-WHITE40': COLORS.WHITE40,
  'L-GRAY60-D-WHITE40': COLORS.WHITE40,
  'L-GRAY130-D-BLACK60': COLORS.BLACK60,
  'L-WHITE-D-GRAY180': COLORS.GRAY180,
  'L-GRAY400-D-GRAY410': COLORS.GRAY410,
}
